import { render, staticRenderFns } from "./FilePreviewDialog.vue?vue&type=template&id=5225aabc&scoped=true"
import script from "./FilePreviewDialog.vue?vue&type=script&lang=js"
export * from "./FilePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewDialog.vue?vue&type=style&index=0&id=5225aabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5225aabc",
  null
  
)

export default component.exports